import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography } from "@mui/material";

const AddStandardModal = ({ open, onClose, newStandardName, setNewStandardName, handleAddStandard, loading }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Standard</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Create a new compliance standard to manage requirements.
        </Typography>
        <TextField
          fullWidth
          label="Standard Name"
          value={newStandardName}
          onChange={(e) => setNewStandardName(e.target.value)}
          placeholder="Enter standard name"
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            color: "#0000a0",
            borderColor: "#0000a0",
            borderRadius: "4px",
            cursor: "pointer",
            border: "1px solid #0000a0",
            backgroundColor: "transparent",
          }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleAddStandard}
          disabled={loading || !newStandardName.trim()}
          variant="contained"
          sx={{ bgcolor: "#0000a0", borderRadius: "4px" }}
        >
          {loading ? "Adding..." : "Add Standard"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddStandardModal;
